import _defineProperty from "/drone/src/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutProperties from "/drone/src/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["label", "before", "after", "disableLabelEffect", "multiline", "onMouseOut", "onMouseOver", "outline", "error", "large", "enableFocusOnRootClick", "enableRootRef", "onRootClick", "autoComplete", "autoFocus", "defaultValue", "disabled", "name", "placeholder", "readOnly", "rows", "value", "onClick", "onKeyDown", "onKeyUp", "onFocus", "onBlur", "onChange", "type", "max", "maxLength", "min", "minLength", "tabIndex"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { useCallback, useRef } from 'react';
import { useEvents } from './useEvents';
import { useInternalRef } from '../../../utils';
export var useTextInput = function useTextInput(_ref, ref) {
  var label = _ref.label,
      before = _ref.before,
      after = _ref.after,
      disableLabelEffect = _ref.disableLabelEffect,
      multiline = _ref.multiline,
      onMouseOut = _ref.onMouseOut,
      onMouseOver = _ref.onMouseOver,
      outline = _ref.outline,
      error = _ref.error,
      large = _ref.large,
      enableFocusOnRootClick = _ref.enableFocusOnRootClick,
      enableRootRef = _ref.enableRootRef,
      onRootClick = _ref.onRootClick,
      autoComplete = _ref.autoComplete,
      autoFocus = _ref.autoFocus,
      defaultValue = _ref.defaultValue,
      disabled = _ref.disabled,
      name = _ref.name,
      placeholder = _ref.placeholder,
      readOnly = _ref.readOnly,
      rows = _ref.rows,
      value = _ref.value,
      onClick = _ref.onClick,
      onKeyDown = _ref.onKeyDown,
      onKeyUp = _ref.onKeyUp,
      onFocus = _ref.onFocus,
      onBlur = _ref.onBlur,
      onChange = _ref.onChange,
      type = _ref.type,
      max = _ref.max,
      maxLength = _ref.maxLength,
      min = _ref.min,
      minLength = _ref.minLength,
      tabIndex = _ref.tabIndex,
      restRootProps = _objectWithoutProperties(_ref, _excluded);

  var _useEvents = useEvents({
    value: value,
    defaultValue: defaultValue,
    placeholder: placeholder,
    disableLabelEffect: disableLabelEffect,
    onFocus: onFocus,
    onBlur: onBlur,
    onMouseOut: onMouseOut,
    onMouseOver: onMouseOver,
    onChange: onChange,
    readOnly: readOnly
  }),
      isMouseInside = _useEvents.isMouseInside,
      isLabelInside = _useEvents.isLabelInside,
      isFocused = _useEvents.isFocused,
      onInputMouseOver = _useEvents.onInputMouseOver,
      onInputMouseOut = _useEvents.onInputMouseOut,
      onInputFocus = _useEvents.onInputFocus,
      onInputBlur = _useEvents.onInputBlur,
      onInputChange = _useEvents.onInputChange;

  var internalInputRef = useRef(null);
  var rootRef = useRef(null);
  var innerContainerRef = useRef(null);
  useInternalRef(ref, enableRootRef ? rootRef : internalInputRef);
  var onRootNodeClick = useCallback(function (event) {
    if (!enableFocusOnRootClick) {
      return;
    }

    if (onRootClick) {
      onRootClick(event);
    }

    if (event.target !== rootRef.current && event.target !== innerContainerRef.current) {
      return;
    }

    if (internalInputRef.current) {
      internalInputRef.current.focus();
    }
  }, [internalInputRef, enableFocusOnRootClick, onRootClick]);
  var Tag = multiline ? 'textarea' : 'input';
  var isOutlined = isMouseInside || isFocused || outline;
  return {
    rootProps: _objectSpread(_objectSpread({}, restRootProps), {}, {
      onClick: onRootNodeClick,
      ref: rootRef,
      error: error,
      multiline: multiline,
      onMouseOver: onInputMouseOver,
      onMouseOut: onInputMouseOut,
      outlined: isOutlined,
      disabled: disabled,
      enableFocusOnRootClick: enableFocusOnRootClick
    }),
    innerContainerProps: {
      multiline: multiline,
      ref: innerContainerRef
    },
    inputProps: {
      autoComplete: autoComplete,
      autoFocus: autoFocus,
      defaultValue: defaultValue,
      disabled: disabled,
      name: name,
      placeholder: placeholder,
      readOnly: readOnly,
      rows: rows,
      value: value,
      onClick: onClick,
      onKeyDown: onKeyDown,
      onKeyUp: onKeyUp,
      max: max,
      maxLength: maxLength,
      min: min,
      minLength: minLength,
      tabIndex: tabIndex,
      multiline: multiline,
      large: large,
      type: multiline ? undefined : type,
      onBlur: onInputBlur,
      onFocus: onInputFocus,
      onChange: onInputChange
    },
    inputLabelProps: {
      disabled: disabled,
      error: error,
      inside: isLabelInside,
      large: large,
      outlined: isOutlined,
      value: value
    },
    inputLabelBackgroundProps: {
      disabled: disabled
    },
    isLabelInside: isLabelInside,
    Tag: Tag,
    before: before,
    after: after,
    disabled: disabled,
    large: large,
    label: label,
    error: error,
    internalInputRef: internalInputRef
  };
};